import { useState } from 'react';
import lodash from 'lodash';
import {
  Create,
  SaveButton,
  Toolbar,
  useCreate,
  useGetList,
  useNotify,
  useRedirect,
  useResourceContext,
} from 'react-admin';
import SaveIcon from '@mui/icons-material/Save';
import { WizardForm } from '../../components';
import { ContractFuel, ContractProduct } from '../../models';
import { getChainId, getUserId } from '../../utils/utils';
import { BasicInfoStep, RulesStep, DealsStep, SummaryStep } from './Steps';

const ContractCreate = (props) => {
  const [create] = useCreate();
  const notify = useNotify();
  const redirect = useRedirect();
  const resource = useResourceContext();

  const [chatData, setChatData] = useState(null);
  const chainId = getChainId();

  const { data: fuels } = useGetList('fuels', { sort: { field: 'name', order: 'ASC' }, pagination: null });

  const createChatMessage = ({ contractId, subject, body, chatFiles, participantIds }) => new Promise((resolve, reject) => {
    if (subject || body || chatFiles) {
      notify('Enviando sua mensagem');

      const data = {
        subject: subject || '(Sem assunto)',
        chatMessage: {
          body,
          files: chatFiles,
        },
        employeeId: getUserId(),
        chainId: getChainId(),
        origin: 'contract',
        contractId,
      }

      if (participantIds) {
        data.participantIds = participantIds;
      }

      create('chats', { data }, {
        onSettled: (_data, error) => {
          if (error.status) {
            notify(error.message || 'Não foi possível encaminhar a mensagem, mas pode ser feito uma nova tentativa na tela de notas fiscais', { type: 'warning' });
            reject(error);
            return;
          }

          notify('Mensagem enviada');
          resolve(_data);
        }
      });
    } else {
      resolve(null);
    }
  });

  return (
    <Create
      {...props}
      title='Criar Contrato'
      record={chainId ? { chainId } : undefined}
      transform={({ subject, body, chatFiles, participantIds, ...data }) => {
        setChatData({ subject, body, chatFiles, participantIds });

        if (data.contractProducts?.length) {
          data.contractProducts = data.contractProducts.map(contractProduct => lodash.omitBy(new ContractProduct(contractProduct), lodash.isNil));
        }

        if (data.contractFuels?.length) {
          data.contractFuels = data.contractFuels.map(contractFuel => new ContractFuel(contractFuel));
        }

        return { ...data, chainId: data.chainId || chainId };
      }}
      mutationOptions={{
        onSuccess: (props) => {
          createChatMessage({ ...chatData, contractId: props.id })
            .finally(() => {
              redirect('list', resource);
            });
        },
        onError: (error) => {
          if (error.status) {
            notify(error.message || 'Não foi possível criar o contrato', { type: 'warning' });
            return;
          }
        }
      }}
      redirect="list"
    >
      <WizardForm
        formSteps={[
          {
            label: 'Informações Básicas',
            component: <BasicInfoStep chainId={chainId} />,
          },
          {
            label: 'Regras e Faturamento',
            component: <RulesStep />,
          },
          {
            label: 'Acordos',
            component: <DealsStep fuels={fuels} />,
          },
          {
            label: 'Resumo',
            component: <SummaryStep />,
            customToolbar: (
              <Toolbar>
                <SaveButton
                  label="Criar Contrato"
                  icon={<SaveIcon />}
                />
              </Toolbar>
            ),
          },
        ]}
      />
    </Create>
  );
};

export default ContractCreate;
